import React, { useMemo } from "react"
import { Col, Row, Spin } from "antd"
import { useTranslation } from "react-i18next"
import { filterRolesByType, getAvailableRolesForReassignment } from "./utils/rolesAccessHelpers"
import { useRolesAccess } from "./hooks/useRolesAccess"
import RolesList from "./components/RolesList"
import PermissionsPanel from "./components/PermissionsPanel"
import RoleModals from "./components/RoleModals"
import styles from "./index.module.css"

const RolesAccess = () => {
  const { t } = useTranslation()

  const {
    roles,
    rolesLoading,
    roleLoading,
    assignedStaffForRole,
    selectedRoleForAccess,
    selectedRoleDetails,
    setSelectedRoleForAccess,
    isAddRoleModalOpen,
    isEditRoleModalOpen,
    isDeleteRoleModalOpen,
    editingRole,
    deletingRole,
    handleAddRole,
    handleRoleEdit,
    handleRoleDelete,
    handleConfirmDelete,
    handleCloseDeleteModal,
    handleSaveNewRole,
    handleSaveEditRole,
    handleCloseAddModal,
    handleCloseEditModal,
    handlePermissionChange
  } = useRolesAccess()

  const administrativeRoles = useMemo(() => filterRolesByType(roles, "administrative"), [roles])
  const experienceRoles = useMemo(() => filterRolesByType(roles, "experience"), [roles])
  const availableRolesForReassignment = useMemo(() => getAvailableRolesForReassignment(roles, deletingRole?.id), [roles, deletingRole])

  if (rolesLoading && roles?.length === 0) {
    return (
      <div className={`commonGrid ${styles.loadingContainer}`}>
        <Spin size="large" />
      </div>
    )
  }

  return (
    <div className="commonGrid">
      <Row gutter={[24, 16]}>
        <Col xs={24} md={10} lg={8} xl={8} xxl={6}>
          <RolesList
            administrativeRoles={administrativeRoles}
            experienceRoles={experienceRoles}
            selectedRoleId={selectedRoleForAccess?.id}
            onRoleClick={setSelectedRoleForAccess}
            onRoleEdit={handleRoleEdit}
            onRoleDelete={handleRoleDelete}
            onAddRole={handleAddRole}
            t={t}
          />
        </Col>
        <Col xs={24} md={14} lg={16} xl={16} xxl={18}>
          <PermissionsPanel selectedRole={selectedRoleDetails} t={t} onPermissionChange={handlePermissionChange} loading={roleLoading} />
        </Col>
      </Row>
      <RoleModals
        isAddRoleModalOpen={isAddRoleModalOpen}
        isEditRoleModalOpen={isEditRoleModalOpen}
        isDeleteRoleModalOpen={isDeleteRoleModalOpen}
        editingRole={editingRole}
        deletingRole={deletingRole}
        assignedStaffForRole={assignedStaffForRole}
        availableRoles={availableRolesForReassignment}
        onCloseAddModal={handleCloseAddModal}
        onCloseEditModal={handleCloseEditModal}
        onCloseDeleteModal={handleCloseDeleteModal}
        onSaveNewRole={handleSaveNewRole}
        onSaveEditRole={handleSaveEditRole}
        onConfirmDelete={handleConfirmDelete}
      />
    </div>
  )
}

export default RolesAccess
